import React from "react";
import { motion, type Variants } from "framer-motion";

type RevealProps = {
    children: React.ReactNode;
    className?: string;
    delay?: number;
};

export const fadeUp: Variants = {
    hidden: { opacity: 0, y: 28 },
    visible: (delay = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] as const, delay },
    }),
};

export const staggerContainer: Variants = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.1, delayChildren: 0.05 },
    },
};

export const CrmReveal = ({ children, className, delay = 0 }: RevealProps) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.15 }}
        variants={fadeUp}
        custom={delay}
    >
        {children}
    </motion.div>
);

export const CrmStagger = ({ children, className }: { children: React.ReactNode; className?: string }) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        variants={staggerContainer}
    >
        {children}
    </motion.div>
);

export const CrmStaggerItem = ({ children, className }: { children: React.ReactNode; className?: string }) => (
    <motion.div className={className} variants={fadeUp}>
        {children}
    </motion.div>
);
